// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=22e09bc7-1012-43e8-b45d-22b2fe6aec5f";
};